import {Icon, Typography} from '@mui/material'
import {menuIcons} from 'constants/sideMenu'

const PageTitle = ({title, key}) => {
    const IconComponent = menuIcons[key]

    return (
        <div style={{display: 'flex'}}>
            {IconComponent && <Icon component={IconComponent} />}
            <Typography>{title}</Typography>
        </div>
    )
}

export default PageTitle
